// https://reactjsexample.com/simple-and-accessible-loading-indicators-with-react/

import React from "react";
import { useLoading } from "@agney/react-loading";
import {
    Audio,
    BallTriangle,
    Bars,
    Circles,
    Grid,
    Hearts,
    Oval,
    Puff,
    Rings,
    SpinningCircles,
    TailSpin,
    ThreeDots,
} from '@agney/react-loading';

import "../../Components/Indicator/LoaderView.css";

export default function LoaderView(args) {
    const { containerProps, indicatorEl } = useLoading({
        loading: true,
        indicator: <Puff width="25%" />,
    });

    return (
        <div className={`Indicator ${args && args.classname ? args.classname :""}`}>
            <p>
                {args.header}
            </p>
            <section {...containerProps}>
                {indicatorEl} {/* renders only while loading */}
            </section>
            <p>
                {args.footer}
            </p>
        </div>
    );
}
